module.exports = __webpack_public_path__ + "static/media/vsc.7127a9a5.png";